export function createTrackConfig() {
  return {
    // 分享埋点
    // 从app端转过来的
    poizon_activity_sign_block_click(platform: string) {
      if (platform !== 'sensors') return

      return {
        current_page: 810,
        block_type: 1478,
        SK: window.dw.getSk(),
      }
    },
  }
}
